import { render, staticRenderFns } from "./viewQuiz.vue?vue&type=template&id=79dc36d5&"
import script from "./viewQuiz.vue?vue&type=script&lang=js&"
export * from "./viewQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports